import NamedDto from 'modules/base/dto/NamedDto';
import AspectInputAttributeEditDto from './AspectInputAttributeEditDto';
import AspectOutputAttributeEditDto from './AspectOutputAttributeEditDto';

export class AspectEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.dataset = null;
		/** @type {number} */
		this.model = null;
		/** @type {string} */
		this.description = null;
		/** @type {AspectInputAttributeEditDto[]} */
		this.inputAttributes = null;
		/** @type {AspectOutputAttributeEditDto[]} */
		this.outputAttributes = null;
		/** @type {boolean} */
		this.datasetList = null;
		/** @type {object} */
		this.roundDigits = null;
		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _AspectEditDtoProps
	 * @property {number} dataset
	 * @property {number} model
	 * @property {string} description
	 * @property {AspectInputAttributeEditDto[]} inputAttributes
	 * @property {AspectOutputAttributeEditDto[]} outputAttributes
	 * @property {object} roundDigits
	 * @property {number} userGroup	
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _AspectEditDtoProps} AspectEditDtoProps
	 */
	/**
	 *
	 * @param {AspectEditDtoProps} props
	 * @returns {AspectEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.dataset = props.dataset;
		this.model = props.model;
		this.description = props.description;
		this.inputAttributes = props.inputAttributes !== null ? props.inputAttributes.map(d => new AspectInputAttributeEditDto().setup(d)) : [];
		this.outputAttributes = props.outputAttributes !== null ? props.outputAttributes.map(d => new AspectOutputAttributeEditDto().setup(d)) : [];
		this.datasetListChanged = false;
		this.roundDigits = props.roundDigits ? Object.entries(props.roundDigits).map(([type, value]) => ({ type, value })) : [];
		this.userGroup = props.userGroup;
		return this;
	}
}

export default AspectEditDto;
